import React, { useState, useEffect } from "react"
import types from "prop-types"
import { FormsyMultiLineMentionableInput } from "shared/inputs"
import * as API from "services/api"

const EntryValue = ({
  name, initialValue, assigneeIds = [], memberIds = [],
}) => {
  const [value, setValue] = useState(initialValue);
  const [users, setUsers] = useState([])

  useEffect(() => {
    const loadUsers = async () => {
      const response = await API.getUsers({ active: true })

      if (response.ok) {
        setUsers(response.data)
      }
    }

    loadUsers()
  }, [])

  return (
    <div className="p-8 bg-white rounded-lg">
      <FormsyMultiLineMentionableInput
        users={users.filter((user) => [...memberIds, ...assigneeIds].includes(user.id))}
        className="max-h-64 overflow-y-auto"
        name={name}
        onChange={(val) => setValue(val)}
        required
        validations={{
          isNotBlankString: true,
          noExcelMetacharacters: true,
          noHTML: true,
        }}
        validationErrors={{ isDefaultRequiredValue: "required" }}
        value={value || ""}
      />
    </div>
  )
}

EntryValue.propTypes = {
  name: types.string.isRequired,
  initialValue: types.string.isRequired,
  memberIds: types.arrayOf(types.number),
  assigneeIds: types.arrayOf(types.number),
}

export default EntryValue
